import React from 'react';
import { Shield, Star, Users, Award, Heart, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

/**
 * Trust Signals Component
 * Displays credibility indicators and reassurance elements
 */
const TrustSignals = ({ variant = 'full' }) => {
  const signals = [
    {
      icon: Shield,
      title: "Fully Insured",
      description: "Licensed and insured for your peace of mind"
    },
    {
      icon: Star,
      title: "5-Star Rated",
      description: "Trusted by Brevard County residents"
    },
    {
      icon: Users,
      title: "Consistent Team",
      description: "Same trusted cleaners every visit"
    },
    {
      icon: Heart,
      title: "Locally Owned",
      description: "Husband & wife team serving our community"
    }
  ];

  if (variant === 'compact') {
    return (
      <div className="flex flex-wrap justify-center gap-6 py-8">
        {signals.map((signal, idx) => {
          const Icon = signal.icon;
          return (
            <div key={idx} className="flex items-center gap-2 text-gray-700">
              <Icon className="w-5 h-5 text-cyan-600" />
              <span className="font-semibold text-sm">{signal.title}</span>
            </div>
          );
        })}
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {signals.map((signal, idx) => {
          const Icon = signal.icon;
          return (
            <div key={idx} className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-200">
              <Icon className="w-6 h-6 text-cyan-600 flex-shrink-0" />
              <span className="font-semibold text-sm text-gray-900">{signal.title}</span>
            </div>
          );
        })}
      </div>
    );
  }

  // Full variant with cards
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {signals.map((signal, idx) => {
        const Icon = signal.icon;
        return (
          <Card key={idx} className="border-2 hover:border-cyan-200 transition-colors">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{signal.title}</h3>
              <p className="text-sm text-gray-600">{signal.description}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default TrustSignals;
